import React, { FC } from 'react';
import Feedback from '../feedback/Feedback';
import Label from '../label/Label';

export interface Props {
  touched: boolean | undefined;
  error: string | undefined;
  hiddenText: boolean | undefined;
  textColor: string | undefined;
  required: boolean | undefined;
  label: string;
  visible: boolean | undefined;
  size: number;
  children: React.ReactNode;
  name?: string | undefined;
}

const FieldWrapper: FC<Props> = ({
  visible,
  size,
  hiddenText,
  textColor,
  required,
  label,
  error,
  touched,
  children,
  name,
}: Props) => {
  if (visible) {
    return (
      <div className={`col-md-${size} form-group`}>
        <Label hidden={hiddenText} textColor={textColor} required={required} label={label} />
        {children}
        <Feedback touched={touched} error={error} name={name} />
      </div>
    );
  }
  return null;
};

export default FieldWrapper;
